import request from '../utils/backend';
import env from '../environment';
import * as actions from '../constants/taskActions';
import * as logEntryActions from '../constants/logEntryActions';
import * as events from '../constants/eventActions';

import * as entityUtils from '../utils/entityUtils';

const taskActions = {

    close(taskID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .post(env.tashi + '/tasks/' + taskID + '/close')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.closeTask({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.closeTask({ status: "success", data: taskID }));
                    } else {
                        dispatch(actions.closeTask({ status: "failure", data: res.status }));
                    }

                });
        };
    },

    create(task) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());
            request
                .post(env.tashi + '/tasks/create')
                .withCredentials()
                .accept('application/json')
                .send(task)
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.createTask({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "create task" }));
                        return;
                    }

                    if (res.ok) {

                        let newTask = JSON.parse(res.text);

                        dispatch(actions.createTask({ status: "success", data: newTask }));
                        
                        dispatch(events.pushSuccessEvent({ data: "create task" }));
                    } else {
                        dispatch(actions.createTask({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "create task" }));
                    }
                });
        };
    },

    createTimer(task, logEntry) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .post(env.tashi + '/tasks/' + task.id + '/newTimer')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.createTimer({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "start timing task" }));
                        return;
                    }

                    if (res.ok) {
                        //we need the ID of the newly created timed log entry
                        logEntry.id = entityUtils.getIDFromLink(res.header.location);

                        //will only the loading icon
                        dispatch(actions.createTimer({ status: "success" }));

                        //will put the new, timed log entry into store
                        dispatch(logEntryActions.createLogEntry({ status: "success", data: logEntry }));

                        dispatch(events.pushSuccessEvent({ data: "start timing task" }));
                    } else {
                        dispatch(actions.createTimer({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "start timing task" }));
                    }
                });
        };
    },

    delete(taskID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());
            request
                .post(env.tashi + '/tasks/' + taskID + '/delete')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.deleteTask({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "delete task" }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.deleteTask({ status: "success", data: taskID }));
                        dispatch(events.pushSuccessEvent({ data: "delete task" }));
                    } else {
                        dispatch(actions.deleteTask({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "delete task" }));
                    }

                });
        };
    },

    deleteFavorite(task) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .del(env.tashi + '/tasks/' + task.id + '/favorite')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.deleteFavoriteTask({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.deleteFavoriteTask({ status: "success", data: task }));
                    } else {
                        dispatch(actions.deleteFavoriteTask({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    edit(taskID, task) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .post(env.tashi + '/tasks/' + taskID + '/edit')
                .withCredentials()
                .accept('application/json')
                .send(task)
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.editTask({ status: "failure", data: err }));
                        dispatch(events.pushErrorEvent({ data: "edit task" }));
                        return;
                    }

                    if (res.ok) {
                        task.id = taskID;
                        dispatch(actions.editTask({ status: "success", data: task }));
                        dispatch(events.pushSuccessEvent({ data: "edit task" }));
                    } else {
                        dispatch(actions.editTask({ status: "failure", data: res.status }));
                        dispatch(events.pushErrorEvent({ data: "edit task" }));
                    }
                });
        };
    },

    isDeletable(taskID) {
        return dispatch => {
            request
                .get(env.tashi + '/tasks/isDeletable/' + taskID)
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.isDeletable({ status: "failure", data: err}));
                        return;
                    }
            
                    let data = JSON.parse(res.text);
                    dispatch(actions.isDeletable({ status: "success", data: data }));
                });
        }
    },

    loadAssignableToUserByProject(userID, projectID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .get(env.tashi + '/tasks/search/findAssignableToUserByParent')
                .query({
                    user: userID,
                    parent: projectID
                })
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if(err) {
                        dispatch(actions.loadTasksAssignableToUserByProject({ status: "failure", data: err}));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.tasks : [];

                    if(data) {
                        dispatch(actions.loadTasksAssignableToUserByProject({ status: "success", data: data}));
                    } else {
                        dispatch(actions.loadTasksAssignableToUserByProject({ status: "success", data: []}));
                    }
                });
        };
    },

    loadByProject(projectID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .get(env.tashi + '/tasks/loadByProject')
                .query({
                    parent: projectID
                })
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadTasksByProject({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data) {
                        dispatch(actions.loadTasksByProject({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadTasksByProject({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadByUser(userID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .get(env.tashi + '/tasks/search/findAllByUser')
                .accept('application/json')
                .withCredentials()
                .query({
                    user: userID
                })
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadTasksByUser({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.tasks : null;

                    if (data) {
                        dispatch(actions.loadTasksByUser({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadTasksByUser({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadFavorite() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .get(env.tashi + '/tasks/search/getFavorite')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadFavoriteTasks({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.tasks : null;

                    if (data) {
                        dispatch(actions.loadFavoriteTasks({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadFavoriteTasks({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadMostFrequentlyUsed() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .get(env.tashi + '/tasks/search/getMostFrequentlyUsed')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadMostFrequentlyUsedTasks({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.tasks : null;

                    if (data) {
                        dispatch(actions.loadMostFrequentlyUsedTasks({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadMostFrequentlyUsedTasks({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadOthers() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .get(env.tashi + '/tasks/search/getOthers')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadOtherTasks({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.tasks : null;

                    if (data) {
                        dispatch(actions.loadOtherTasks({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadOtherTasks({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadRecentlyAssigned() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .get(env.tashi + '/tasks/search/getRecentlyAssigned')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadRecentlyAssignedTasks({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded ? JSON.parse(res.text)._embedded.tasks : null;

                    if (data) {
                        dispatch(actions.loadRecentlyAssignedTasks({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadRecentlyAssignedTasks({ status: "success", data: [] }));
                    }
                });
        };
    },

    loadTasks() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .get(env.tashi + '/tasks')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadTasks({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded.tasks;

                    if (data) {
                        dispatch(actions.loadTasks({ status: "success", data: data }));
                    } else {
                        dispatch(actions.loadTasks({ status: "success", data: [] }));
                    }
                });
        };
    },

    pmLoadAll() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .get(env.tashi + '/tasks/search/pm_findAll')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.pmLoadAllTasks({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded.tasks;

                    if (data) {
                        dispatch(actions.pmLoadAllTasks({ status: "success", data: data }));
                    } else {
                        dispatch(actions.pmLoadAllTasks({ status: "success", data: [] }));
                    }
                });
        };
    },

    pmoLoadAll() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .get(env.tashi + '/tasks/search/pmo_findAll')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.pmoLoadAllTasks({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded.tasks;

                    if (data) {
                        dispatch(actions.pmoLoadAllTasks({ status: "success", data: data }));
                    } else {
                        dispatch(actions.pmoLoadAllTasks({ status: "success", data: [] }));
                    }
                });
        };
    },

    reopen(taskID) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .post(env.tashi + '/tasks/' + taskID + '/reopen')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.reopenTask({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.reopenTask({ status: "success", data: taskID }));
                    } else {
                        dispatch(actions.reopenTask({ status: "failure", data: res.status }));
                    }

                });
        };
    },

    setColor(task) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .post(env.tashi + '/tasks/' + task.id + '/color')
                .withCredentials()
                .accept('application/json')
                .send(task.color)
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.setColorTask({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.setColorTask({ status: "success", data: task }));
                    } else {
                        dispatch(actions.setColorTask({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    setFavorite(task) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForTaskState());

            request
                .post(env.tashi + '/tasks/' + task.id + '/favorite')
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.setFavoriteTask({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.setFavoriteTask({ status: "success", data: task }));
                    } else {
                        dispatch(actions.setFavoriteTask({ status: "failure", data: res.status }));
                    }

                });
        };
    },

    setSelectedTask(task) {
        return dispatch => dispatch(actions.setSelectedTask(task));
    }

};

export default taskActions;


/** WEBPACK FOOTER **
 ** ./src/app/actions/taskActionCreators.js
 **/